$(document).ready(function(){
  $('#FeaturesSelectorForm').submit(function(e){
      e.preventDefault()
      var url = $(this).attr('action');
      $('#loading').show();
      $.ajax({
        url    : url,
        cache  : false,
        method : 'POST',
        data   :  $(this).serialize(),
        success: function(data) {
          $('#loading').hide();
          $('#results').html(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log('deu erro');
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        }
      });
  })
  $('#Form_ContactForm').attr('autocomplete', 'off');
  $('#Form_ContactForm').submit(function(e){
    e.preventDefault()
    var url = $(this).attr('action');
    $('#loading').show();
    $.ajax({
      url    : url,
      cache  : false,
      method : 'POST',
      data   :  $(this).serialize(),
      success: function(data) {
        $('#loading').hide();
      if(data.includes('Please answer the captcha, if you do not see the captcha please enable JavaScript')){
        $('#results').html('Please answer the captcha, if you do not see the captcha please enable JavaScript.');
      }
      else{
        $('#results').html(data);
        if(data.includes('Thank')){
          setTimeout(function () { $('#Form_ContactForm')[0].reset();  $('#results').html(''); }, 5000);
        }
      }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log('deu erro');
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
      }
    });
})
})



// WEBPACK FOOTER //
// ./assets/js/features.js